import { useEffect, useRef } from "react";
import { HERO } from "../../content/copy";
import { BookCover } from "../Media";
import { Reveal } from "../Reveal";
import { SplitHeadline } from "../fx/SplitHeadline";
import { SectionMark, Folio, RegMarks } from "../fx/Marginalia";

const MsCounter = () => {
  const ref = useRef(null);
  useEffect(() => {
    let raf;
    const tick = () => {
      if (ref.current) ref.current.textContent = Math.floor(performance.now()).toString().padStart(7, "0").replace(/\B(?=(\d{3})+(?!\d))/g, " ");
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, []);
  return (
    <div className="ms-counter mono" data-testid="hero-ms-counter">
      <span className="ms-label">{HERO.counterLabel}</span>
      <span className="ms-value">
        <span ref={ref} data-testid="hero-ms-counter-value">0 000 000</span>
        <span className="ms-unit"> ms</span>
      </span>
    </div>
  );
};

const Monitor = () => (
  <Reveal className="monitor" delay={400} data-testid="hero-monitor">
    <div className="monitor-head mono" aria-hidden="true">
      <span>MON/01</span>
      <span className="monitor-live">LIVE</span>
    </div>
    <p className="tech-line mono glitch" data-testid="hero-tech-line">{HERO.tech}</p>
    <MsCounter />
    <p className="hero-log mono" data-testid="hero-fixed-log">
      {HERO.log}
      <span className="cursor" aria-hidden="true" />
    </p>
  </Reveal>
);

export const HeroCover = () => (
  <section className="hero" data-testid="hero-section" data-rail="01">
    <RegMarks />
    <div className="frame hero-frame">
      <div className="hero-top">
        <SectionMark n="01" label="APERTURA" />
        <Monitor />
      </div>
      <SplitHeadline
        as="h1"
        className="hero-title"
        text={HERO.title}
        breaks={[4, 4, 3, 2]}
        indents={[0, 1, 0, 2]}
        emIdx={[9, 10]}
        delay={150}
        testid="hero-title"
      />
      <div className="hero-bottom">
        <Reveal as="p" className="hero-sub" delay={900} data-testid="hero-subtitle">{HERO.subtitle}</Reveal>
        <Reveal className="hero-cover" variant="mask" delay={500}>
          <BookCover />
        </Reveal>
      </div>
      <div className="hero-foot">
        <Reveal className="scroll-cue" delay={1500} data-testid="hero-scroll-cue">
          <span className="scroll-line" aria-hidden="true" />
          <span className="serif">{HERO.scrollCue}</span>
        </Reveal>
        <Folio n="01" />
      </div>
    </div>
  </section>
);
